import { render, staticRenderFns } from "./AppAgreement.vue?vue&type=template&id=390a8ceb&functional=true&"
import script from "./AppAgreement.vue?vue&type=script&lang=js&"
export * from "./AppAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports